import { create } from 'zustand'
import { QrParserResult, QrScannerMode, parseQrCode } from './parseQrCode'
import nanoid from '@ui/utils/nanoid'

type RemoveCallback = () => void

export type QrResultCallback = (result: QrParserResult) => void

type Callbacks = Map<string, (result: QrParserResult) => void>

type QrScannerStore = {
  mode: QrScannerMode
  setMode: (mode: QrScannerMode) => void
  callbacks: Callbacks
  addCallback: (callback: QrResultCallback) => RemoveCallback
  handleResult: (result: string) => void
  visible: boolean
  open: () => void
  close: () => void
}

export const useQrScanner = create<QrScannerStore>((set, get) => ({
  mode: 'disabled',
  callbacks: new Map(),
  addCallback: (callback) => {
    const id = nanoid()

    set((state) => {
      const updated = new Map(state.callbacks)
      updated.set(id, callback)
      return {
        callbacks: updated,
      }
    })

    return () =>
      set((state) => {
        const updated = new Map(state.callbacks)
        updated.delete(id)
        return {
          callbacks: updated,
        }
      })
  },
  handleResult: (result) => {
    const { callbacks, mode } = get()
    const parsed = parseQrCode(result, mode)
    if (!parsed) {
      return
    }
    for (const callback of callbacks.values()) {
      callback(parsed)
    }
  },
  setMode: (mode: QrScannerMode) => set({ mode }),
  visible: false,
  open: () => set({ visible: true }),
  close: () => set({ visible: false }),
}))
